<div *ngIf="planningTeam"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4"
    (click)="$event.preventDefault(); closeModal();">
    <div class="w-full max-w-screen-md max-h-[90%] flex flex-row gap-1 justify-center overflow-y-auto"
        (click)="$event.stopPropagation()">
        <!-- EVENT DETAILS -->
        <div class="flex min-w-full bg-white p-10 w-1/4 rounded-md text-center shadow-lg">
            <div class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto">
                <div class="w-full flex flex-row gap-8 items-center justify-between">
                    <h2 class="w-full oswald-font text-xl uppercase text-nside-orange-400 font-medium text-start whitespace-nowrap">
                        Core Planning Team
                    </h2>
                    <button class="p-1 rounded-full hover:bg-gray-100" (click)="$event.preventDefault(); closeModal();">
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>
                <div class="w-full h-full overflow-y-auto">
                    <table class="w-full text-left">
                        <thead class="oswald-font text-lg uppercase">
                            <tr class="border-b border-gray-200">
                                <th scope="col" class="px-6 py-3 bg-gray-50">Department</th>
                                <th scope="col" class="px-6 py-3">Contacts</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let deptInfo of departmentContacts" class="border-b border-gray-200">
                                <th scope="row" class="w-1/2 px-6 py-4 bg-gray-50">
                                    {{ deptInfo.department.department }}
                                </th>
                                <td class="w-1/2 px-6 py-4">
                                    <ng-container *ngIf="deptInfo.contacts.length; else noContacts">
                                        <div *ngFor="let contact of deptInfo.contacts">{{ contact.name }}</div>
                                    </ng-container>
                                    <ng-template #noContacts>
                                        <span class="text-gray-200 italic">No contacts</span>
                                    </ng-template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button (click)="$event.preventDefault(); closeModal();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>